module.exports = __webpack_public_path__ + "img/onboarding3.bf7961c4.png";